<template>
  <b-container>
    <div class="mt-4 mb-4 d-flex align-items-start justify-content-between">
      <!-- Titre et boutons -->
      <div>
        <h1 class="page-title">{{ $t('Partenaires') }}</h1>
        <h2 class="page-subtitle">{{ $t('partenaires.find.2') }}</h2>
      </div>

      <div>
        <b-button variant="primary" @click="clickOnCreateBtn" v-if="isAdmin">
          <plus-icon class="mr-1" size="18"/>
          {{ $t('Add') }} {{ $t('a') }} {{ $t('partenaire') }}
        </b-button>
      </div>
    </div>

    <!-- Liste des partenaires -->
    <template>
      <b-card class="mb-4 p-4">

        <b-form-select
            id="categorie-input"
            class="col-md-2 mb-2"
            :invalid-feedback="categorie.invalidFeedback"
            :state="categorie.state"
            v-model="categorie.value"
            @change="filterItems"
            required>
          <option value="-1">{{ $t("partenaire.Categorie") }}</option>
          <option v-for="option in categories" :value="option">
            {{ option }}
          </option>
        </b-form-select>

        <b-input-group
            class="mr-md-4 mb-4" size="sm"
            style="width: 33%">
          <b-input-group-prepend>
            <b-input-group-text class="search-input-prepend">
              <search-icon size="18"/>
            </b-input-group-text>
          </b-input-group-prepend>
          <b-form-input
              v-model="searchQuery"
              :class="{'active': searchQuery}"
              :placeholder="$t('Research')"
              class="search-input"

              type="search">
          </b-form-input>
        </b-input-group>

        <template v-if="totalCount === 0">
          <div class="empty-state-container">
            <div class="text-center mb-4">
              <img :src="require(`@/assets/images/APRILYOS/empty-table.png`)" alt="no result" class="empty-state-img">
            </div>
            <div class=" text-center no-result-text">
              <div class="no-result-title mb-2">{{ $t('partenaire.emptyTitle') }}</div>
              <b-button class="my-2" variant="primary" @click="clickOnCreateBtn" v-if="isAdmin">
                {{ $t('partenaire.emptyButton') }}
              </b-button>
            </div>
          </div>
        </template>

        <template v-else>
          <h2 class="page-subtitle">{{ totalCount }} {{ $t('partenaires') }}</h2>

          <div class="row">
            <template v-for="partenaire in partenaires">
              <div class="col-sm-1 col-md-3 col-lg-3 my-2">
                <b-card @click="showPartenaire(partenaire.id)" class="w-100 light-border p-2 card-partenaire" style="height: 400px;">
                  <div>
                    <div class="d-flex w-100" style="height: 200px">
                      <img class="m-auto logo-partenaire" v-if="partenaire.logo" :src="getFileUrl(partenaire.logo.fileUrl)" alt="Photo"/>
                      <img v-else class="m-auto logo-partenaire" :src="require(`@/assets/images/APRILYOS/sidebar-logo.png`)" alt="Photo"/>
                    </div>
                    <div class="my-3">
                      <span class="dispo p-2">
                        {{ partenaire.categorie }}
                      </span>
                    </div>
                    <div class="title-partenaire my-2">
                      {{ partenaire.name }}
                    </div>
                    <div class="limite-texte description" v-html="partenaire.description">
                    </div>
                  </div>
                </b-card>

              </div>
            </template>
          </div>
        </template>
      </b-card>
    </template>

  </b-container>
</template>


<script>

import api from "../../services/api";

export default {

  name: 'PartenaireIndex',

  components: {},

  data() {
    return {
      isCollaborator: this.$store.getters.isCollaborator,
      isCollaboratorPlus: this.$store.getters.isCollaboratorPlus,
      isLoading: false,
      totalCount: 0,
      allowCreate: true,
      partenaires: [],
      categories: [],
      searchQuery: "",
      isAdmin: this.$store.getters.isAdmin,
      categorie: {
        state: null,
        invalidFeedback: null,
        value: -1
      },
    }
  },

  async mounted() {
    await this.fetchItems()
    await this.getCategories()
  },

  watch: {
    searchQuery(query) {
      this.filterItems()
    }
  },

  methods: {

    async getCategories() {
      await api.get(`/partenaire/getPartenaireCategories`)
          .then(response => {
            this.categories = response.data
          })
    },

    getFileUrl(itemUrl) {
      return process.env.SERVER_URL + itemUrl
    },

    fetchItems() {
      this.isLoading = true
      api
          .get('/partenaire')
          .then(response => {
            this.partenaires = response.data
            this.totalCount = this.partenaires.length
            this.isLoading = false
          })
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'PartenaireCreate',
      })
    },

    showPartenaire(partenaireId) {
      this.$router.push({
        name: 'PartenaireShow',
        params: {
          partenaireId: partenaireId
        }
      })
    },

    filterItems() {
      this.isLoading = true

      const formData = new FormData()
      formData.append('categorie', this.categorie.value)
      formData.append('searchQuery', this.searchQuery)

      api.post(`/partenaire/getPartenaires`, formData)
          .then(response => {
            this.partenaires = response.data
            this.totalCount = this.partenaires.length
            this.isLoading = false
          })
    }

  }
}
</script>

<style scoped>

.tertiary-color {
  color: var(--tertiary-text-color);
}

.card-body {
  padding: 0 0 0.5rem;
}

.card {
  border-radius: 10px;
  padding: 0;
}

.empty-state-container {
  height: 70%;
  margin-top: 15%;
  margin-bottom: 15%;
}

.empty-state-img {
  max-width: 220px;
}

.no-result-img {
  max-width: 135px;
  max-height: 83px;
}

.picture-container {
  border-radius: 10px 10px 0 0;
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.picture-container .result-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}


.overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: absolute;
  height: 200px;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border-radius: 10px 10px 0 0;
  font-family: Agbalumo-Regular, "Arial", sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 22px;
  z-index: 1;
  opacity: 0.2;
}

.overlay-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: absolute;
  color: white;
  border-radius: 10px 10px 0 0;
  font-family: Agbalumo-Regular, "Arial", sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 22px;
  z-index: 2;
}

.no-result-title {
  font-family: "Montserrat-Bold", "Arial", sans-serif;
  color: var(--main-color-text);
  font-weight: 400;
}

.dispo {
  border-radius: 30px;
  text-align: center;
  background: #f0f3f9;
  color: #6D84C4;
  font-family: "Montserrat-Bold", "Arial", sans-serif;
  font-weight: 700;
}

.limite-texte {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.title-partenaire {
  font-family: "Montserrat-Bold", "Arial", sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0;
}

.description {
  font-family: "Montserrat", "Arial", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 130%;
  letter-spacing: 0;
}

.card-partenaire {
  cursor: pointer;
}

.logo-partenaire {
  height: fit-content;
  max-height: 200px;
  max-width: 100%
}
</style>



// WEBPACK FOOTER //
// src/views/partenaire/PartenaireIndex.vue